'use client';

import React from 'react';
import KickStreamsSection from '@/app/components/KickStreams';
import Partners from '@/app/components/Partners';
import QuickLinks from '@/app/components/QuickLinks';
import MatrixGrid from '@/app/components/MatrixGrid';
import Hero from '@/app/components/Hero';

export default function HomePage() {

  return (
    <div className="min-h-screen text-green-400 overflow-hidden relative mt-15">
      <MatrixGrid />
      {/* Spotlight */}
      <div className="relative mx-auto px-4 py-8">
        <Hero />
        <Partners />
        <QuickLinks />
        <KickStreamsSection />
      </div>
    </div>
  );
}